"use client";

import { AUDIT_REMEDIATION_PLAN, type PackageSummary } from "../pricing";
import { ManageRemediationScreen } from "./ManageRemediationScreen";

/**
 * How many past financial years need auditing.
 *
 * Reached only from a "yes" on the audit-statements step, and repeats that
 * step's heading. Unlike the accounting version this screen asks no
 * sub-question — the intro is a single bold line and the options follow it
 * directly.
 */
export function ManageAuditRemediationStep({
  years,
  onYearsChange,
  summary,
  onNext,
  onSkip,
}: {
  years: string | null;
  onYearsChange: (value: string) => void;
  summary: PackageSummary;
  onNext: () => void;
  onSkip: () => void;
}) {
  return (
    <ManageRemediationScreen
      heading="Need help with audited financial statements from previous years?"
      intro={
        // 24px bold here, against the 18px medium the same sentence had on the
        // previous screen — the design promotes it once it's the standing
        // context for the question rather than the lead-in to a choice.
        <p className="w-full font-suisse-intl-bold text-xl leading-snug text-white sm:text-2xl sm:leading-[38.4px]">
          As your new auditor, we can assist with filing outstanding audited financial statements to
          ensure compliance.
        </p>
      }
      legend="How many previous financial years need auditing?"
      name="audit-remediation-years"
      plan={AUDIT_REMEDIATION_PLAN}
      years={years}
      onYearsChange={onYearsChange}
      summary={summary}
      onNext={onNext}
      onSkip={onSkip}
    />
  );
}
